import WarningIcon from "@mui/icons-material/WarningAmber";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

/**
 * Under a profit figure: how many cases it leaves out, having no fee
 * structure to tell their profit by. Their revenue still counts.
 */
export const WithoutFeeStructure = ({ count }: { count: number }) => {
  const { t } = useTranslation(undefined, { keyPrefix: "portfolio" });
  if (count === 0) return null;
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mt: 0.75 }}>
      <WarningIcon fontSize="small" color="warning" />
      <Typography variant="caption" sx={{ color: "text.secondary" }}>
        {t("withoutFeeStructure", { count })}
      </Typography>
    </Box>
  );
};
